import { UserVerification } from "../cycle-verification.model";
import { ReqVerificationStage } from '../req-verification-stage.model';

export class UserRequestVerification extends UserVerification {
    NotifyUserOfComment: boolean;
    UserNote: string;
    SupervisorNote: string;
    FollowupDueDate: Date;
    FinalStage: boolean;
    IsSkippable: boolean;
    VerificationStages: Array<ReqVerificationStage>;
    UserCycleID: string;
    ShouldReserveSeat?: boolean;
    // Used for returning results for bulk actions
    UserRequestCreatorFirstName: string;
    UserRequestCreatorLastName: string;
    UserRequestDescription: string;
}